<spinner *ngIf="loading"></spinner>
<div class="container-fluid">
    <div class="d-flex justify-content-between align-items-center pb-3">
        <h1 class="h4 mb-0">{{ heading }}</h1>
        <div class="d-flex align-items-center gap-2">
            @if (Permissions.CREATE_CONTRACT | hasPermission) {
                <a class="btn btn-success" [routerLink]="newContractRoute" data-testid="new-contract-btn">
                    + New contract
                </a>
            }
            <button #filtersButton type="button" class="btn btn-outline-secondary"
                    [attr.aria-expanded]="showFilters"
                    (click)="toggleFilters()"
                    data-testid="contracts-filters-btn">
                <i class="bi bi-funnel" aria-hidden="true"></i> Filters
            </button>
        </div>
    </div>

    @if (showFilters) {
        <div class="filter-overlay" (click)="onFilterCancel()"></div>
        <div class="filter-sidebar">
            <cdss-contracts-filter
                [(filter)]="filter"
                [canSeeInactive]="isGeneralAdmin"
                (apply)="onFilterApply()"
                (cancel)="onFilterCancel()">
            </cdss-contracts-filter>
        </div>
    }

    @if (!loading) {
        <overlay-spinner *ngIf="refreshing"></overlay-spinner>
        <ngx-datatable class="bootstrap mt-4" #table
                       [rows]="rows"
                       [columnMode]="'flex'"
                       [headerHeight]="50"
                       [rowHeight]="'auto'"
                       [footerHeight]="0"
                       [limit]="pagination.size"
                       [messages]="{emptyMessage: 'No records found', totalMessage: 'records found'}"
                       (sort)="onSort($event)">

            <ngx-datatable-column prop="title" name="Title" [sortable]="true" [flexGrow]="3">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span>{{ row.title }}</span>
                    @if (statusLabel(row); as status) {
                        <span class="badge text-bg-secondary ms-2" data-testid="contract-status-badge">{{ status }}</span>
                    }
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="code" name="Code" [sortable]="true" [flexGrow]="1.2"></ngx-datatable-column>

            <ngx-datatable-column prop="serviceProvider" name="Service provider" [sortable]="true" [flexGrow]="2">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span>{{ row.serviceProvider || '-' }}</span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="signatureDate" name="Signature date" [sortable]="true" [flexGrow]="1.5">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span>{{ formatDate(row.signatureDate) }}</span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="kickoffDate" name="Kickoff date" [sortable]="true" [flexGrow]="1.5">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span>{{ formatDate(row.kickoffDate) }}</span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Actions" [sortable]="false" [flexGrow]="0.8" [minWidth]="60">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <a class="row-action" [routerLink]="detailRoute(row)"
                       [attr.aria-label]="'Edit contract ' + row.title"
                       data-testid="contract-edit-link">
                        <i class="bi bi-pencil-square" aria-hidden="true"></i>
                    </a>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
    }
</div>
<div class="d-flex align-items-center justify-content-between px-3 mt-2">
    <div>
        Page selector
        <button type="button" class="btn px-2" [ngClass]="{'fw-bolder': pagination.size == 25}" (click)="setPaginationSize(25)">25</button> /
        <button type="button" class="btn px-2" [ngClass]="{'fw-bolder': pagination.size == 50}" (click)="setPaginationSize(50)">50</button> /
        <button type="button" class="btn px-2" [ngClass]="{'fw-bolder': pagination.size == 100}" (click)="setPaginationSize(100)">100</button>
    </div>
    <div aria-live="polite">
        <b>{{ pagination.totalCount }} contracts</b> - Showing {{ pagination.fromRecord }}-{{ pagination.toRecord }}
    </div>
    <div>
        <button type="button" class="btn btn-success rounded-pill fw-bold me-2" [disabled]="pagination.currentPage <= 1" (click)="previousPage()">&lt; PREVIOUS PAGE</button>
        <button type="button" class="btn btn-success rounded-pill fw-bold" [disabled]="pagination.currentPage == pagination.totalPages" (click)="nextPage()">NEXT PAGE &gt;</button>
    </div>
</div>
